import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import axios from 'axios';
import Intro from '.././../components/Intro';
// import Image from "next/image";
import LazyLoad, { lazyload } from 'react-lazyload';
lazyload({
  width: '100%',
});
const Industries = props => {
  const industriesUrl = 'https://admin.weprodigi.com/api/industries';
  const [activeClasses, setActiveClasses] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [width, setWidth] = useState(props.width);
  const industriesCategories = [
    'Food & Beverages',
    'Healthcare',
    'Education',
    'Entertainment',
    'Software Solutions | Apps',
    'Beauty & Fashion',
    'E-commerce',
    'Transportation',
    'Insurance',
    'Government',
    'Retail',
    'Events',
    'Non-Profit',
    'Sport',
    'Legal',
    'Telecommunications',
    'Finance',
    'Construction',
    'HoReCa',
    'Manufacturing',
  ];
  const choose = filterName => {
    const url = new URL(window.location.href);

    if (activeClasses.includes(filterName)) {
      reset();
      url.searchParams.delete('industry');
    } else {
      setActiveClasses([filterName]);
      url.searchParams.set('industry', filterName);
    }
    window.history.pushState({}, '', url);
  };
  const loadIndustries = () => {
    axios
      .get(industriesUrl)
      .then(function (response) {
        setIndustries(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    if (props.width !== width) {
      setWidth(props.width);
    }
  }, [props.width]);
  useEffect(() => {
    const url = new URL(window.location.href);
    const ind = url.searchParams.get('industry');
    if (ind) setActiveClasses(ind);
    loadIndustries();
  }, []);
  const reset = () => {
    setActiveClasses([]);
    const url = new URL(window.location.href);
    url.searchParams.delete('industry');
    window.history.pushState({}, '', url);
  };

  return (
    <>
      <Head>
        <title>Our Clients from Various Industries | Prodigi Marketing Agency</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/industries" />
        <meta
          name="description"
          content="Discover our clients from different industries. Our customized marketing strategies cater to different industries, ensuring optimal results."
        />
        <meta property="og:url" content="https://weprodigi.com/industries" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Our Clients from Various Industries | Prodigi Marketing Agency" />
        <meta
          property="og:description"
          content="Discover our clients from different industries. Our customized marketing strategies cater to different industries, ensuring optimal results."
        />
      </Head>
      <Intro title="OUR CLIENTS FROM VARIOUS" referrer="industry" subTitles="INDUSTRIES" width={width} />
      <div className={` md:block text-center container flex justify-between flex-col items-center container-fluid p-0  pt-[15px] container-fluid`}>
        <div className="filters ">
          <div
            onClick={reset}
            className={`${activeClasses.length === 0 ? '  text-white bg-purple ' : ''} font-normal-bold text-[12px] leading-[15px] border-[1px] border-purple rounded-[5px] inline-block pt-[12px] pl-[18px] pb-[12px] pr-[18px] cursor-pointer mr-[7px] mt-[7px] mb-[7px] uppercase`}
          >
            All
          </div>
          {industriesCategories.map((item, i) => {
            return (
              <div
                onClick={() => choose(item)}
                key={`_filter_` + i}
                className={`${activeClasses.includes(item) ? '   text-white bg-purple ' : ''} font-normal-bold text-[12px] leading-[15px] border-[1px] border-purple rounded-[5px] inline-block pt-[12px] pl-[18px] pb-[12px] pr-[18px] cursor-pointer mr-[7px] mt-[7px] mb-[7px] uppercase`}
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
      <div className={`bg-gray text-center p-[15px] w-auto m-auto `}>
        {width >= 1024 ? (
          <div className=" container flex flex-auto m-auto flex-wrap justify-start">
            <style jsx global>
              {`
                .lazyload-wrapper {
                  width: 100%;
                }
                .client {
                  margin: 5px;
                }
                figure {
                  position: relative;
                  cursor: pointer;
                }
                figure:before {
                  content: '';
                  width: 0;
                  height: 0;
                  opacity: 0.3;
                  position: absolute;
                  left: 0;
                  top: 2px;
                  z-index: 12;
                  border: 144px solid rgb(10 10 10 / 90%);
                }
                figure:hover::before {
                  border-width: 72px;
                  transition: all 0.3s linear 0s;
                }
                figure:not(:hover)::before {
                  border-width: 0;
                  transition: all 0.3s linear 0s;
                  top: 50%;
                  left: 50%;
                }
              `}
            </style>
            {industries.map((item, i) => {
              if (activeClasses.length > 0) {
                if (activeClasses.includes(item.industries)) {
                  return (
                    <a href={item.case_url} className="flex client" key={'_client_' + i}>
                      <figure>
                        <img
                          src={'https://admin.weprodigi.com/' + item.image}
                          width={144}
                          height={144}
                          alt={'client' + item.industries}
                          layout="intrinsic"
                        />
                      </figure>
                    </a>
                  );
                }
              } else {
                return (
                  <a href={item.case_url} className="flex client" key={'_client_' + i}>
                    <figure>
                      <img
                        src={'https://admin.weprodigi.com/' + item.image}
                        width={144}
                        height={144}
                        alt={'client' + item.industries}
                        layout="intrinsic"
                      />
                    </figure>
                  </a>
                );
              }
            })}
          </div>
        ) : (
          <div className="  flex flex-auto m-auto flex-wrap justify-center">
            <style jsx global>
              {`
                .lazyload-wrapper {
                  width: 100%;
                }
              `}
            </style>
            {industries.length > 0 && (
              <>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-full-30 text-green uppercase font-black h-[52px]  bg-FOOD_BEVERAGES -ml-[15px]  -mt-[15px] flex justify-start items-center pl-[15px]">
                    Food & Beverages
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Food & Beverages') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Food & Beverages' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] mt-[10px] bg-Healthcare -ml-[15px] flex justify-start items-center pl-[15px]">
                    Healthcare
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Healthcare') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Healthcare' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Education mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Education
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Education') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Education' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Entertainment mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Entertainment
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Entertainment') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Entertainment' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing  bg-SoftwareSolutionsApps w-[calc(100%+30px)] text-green uppercase font-black h-[52px] mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Software Solutions | Apps
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Software Solutions | Apps') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Software Solutions | Apps' + i}>
                              <img src={'https://admin.weprodigi.com/' + item.image} width={144} height={144} alt={'client' + item.industries} />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-BeautyFashion mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Beauty & Fashion
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Beauty & Fashion') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Beauty & Fashion' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-E-commerce mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    E-commerce
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'E-commerce') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_E-commerce' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Retail mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Retail
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Retail') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Retail' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Events mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Events
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Events') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Events' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Non-Profit mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Non-Profit
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Non-Profit') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Non-Profit' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Transportation mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Transportation
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Transportation') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Transportation' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover  manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Insurance mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Insurance
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Insurance') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Insurance' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Sport mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Sport
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Sport') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Sport' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Legal mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]5">
                    Legal
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Legal') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Legal' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover  manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Telecommunications mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Telecommunications
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Telecommunications') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Telecommunications' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Finance mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Finance
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Finance') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Finance' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Construction mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Construction
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Construction') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Construction' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-HoReCa mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    HoReCa
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'HoReCa') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_HoReCa' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
                <div className={'w-full'}>
                  <div className="heading bg-cover manufacturing w-[calc(100%+30px)] text-green uppercase font-black h-[52px] bg-Manufacturing mt-[10px] -ml-[15px] flex justify-start items-center pl-[15px]">
                    Manufacturing
                  </div>
                  <LazyLoad offset={100}>
                    <div className="clients flex flex-wrap justify-around">
                      {industries.map((item, i) => {
                        if (item.industries === 'Manufacturing') {
                          return (
                            <a href={item.case_url} className="flex" key={'_client_Manufacturing' + i}>
                              <img
                                src={'https://admin.weprodigi.com/' + item.image}
                                width={144}
                                height={144}
                                alt={'client' + item.industries}
                                layout="intrinsic"
                              />
                            </a>
                          );
                        }
                      })}
                    </div>
                  </LazyLoad>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};
export default Industries;
